const fontPrimary = [
  'Inter',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',')

const fontSecondary = [
  'Nunito',
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  '"Helvetica Neue"',
  'Arial',
  'sans-serif',
  '"Apple Color Emoji"',
  '"Segoe UI Emoji"',
  '"Segoe UI Symbol"',
].join(',')

const typography = {
  useNextVariants: true,
  fontFamily: fontPrimary,
  fontSize: 14,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  h1: {
    fontSize: '2rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#343434',
  },
  h2: {
    fontSize: '1.75rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#343434',
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#343434',
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#343434',
  },
  h5: {
    fontSize: '1.125rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#343434',
  },
  h6: {
    fontSize: '1.0625rem',
    fontWeight: 600,
    lineHeight: 1.2,
    color: '#343434',
  },
  body1: {
    fontFamily: fontPrimary,
    fontSize: 14,
    color: '#5D5D5D',
    lineHeight: 1.3,
    fontWeight: 500,
  },
  body2: {
    fontFamily: fontPrimary,
    fontSize: 12,
    fontWeight: 500,
    color: '#5D5D5D',
    lineHeight: 1.3,
  },
  subtitle1: {
    fontWeight: 600,
    fontFamily: fontPrimary,
    fontSize: '1.0rem',
    color: '#343434',
    lineHeight: 1.3,
  },
  subtitle2: {
    fontWeight: 700,
    fontFamily: fontPrimary,
    fontSize: '1.0rem',
    color: '#5D5D5D',
    lineHeight: 1.3,
  },
  overline: {
    fontWeight: 700,
    fontFamily: fontPrimary,
    fontSize: 12,
    color: '#426FFB',
    textTransform: 'uppercase' as any,
  },
  button: {
    fontWeight: 600,
    color: '#FFF',
    // for some some reaason typechecking doesnt like this so using any
    textTransform: 'none' as any,
  },
}

export default typography
